
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.449 4.45a.458.458 0 01-.648 0L2.75 3.397v.727a.458.458 0 11-.917 0V2.292c0-.253.205-.458.458-.458h1.834a.458.458 0 110 .916h-.727l1.05 1.051a.458.458 0 010 .648zM6.551 4.45a.458.458 0 010-.649l1.051-1.05h-.727a.458.458 0 110-.917H8.71c.253 0 .458.205.458.458v1.833a.458.458 0 11-.917 0v-.727L7.2 4.45a.458.458 0 01-.649 0zM4.449 6.55a.458.458 0 010 .649l-1.051 1.05h.727a.458.458 0 110 .917H2.29a.458.458 0 01-.458-.458V6.875a.458.458 0 11.917 0v.727L3.8 6.55a.458.458 0 01.649 0zM6.551 6.55a.458.458 0 01.648 0L8.25 7.603v-.727a.458.458 0 11.917 0v1.833a.458.458 0 01-.458.459H6.875a.458.458 0 110-.917h.727l-1.05-1.051a.458.458 0 010-.648z"}})])
          )
        }
      }
    